<template>
	<div class="app flex-row align-items-center">
		<div class="container-fluid">
            <div class="client-app-inc" style="height:200px" v-if="loading">
                <Loader></Loader>
            </div>
			<slot v-if="!loading">
                <div v-if="is_script" v-html-js="{html: game_data, script:'javascript'}"></div>
                <iframe v-if="!is_script" :src="game_url" style="height:1000px" frameborder="0" width="100%"/>
            </slot>
		</div>
        <div class="mobile-bottom-bar sportsbook" v-if="isMobile" >
            <div class="item" @click="triggerComponent('A_Z_NAV', 'open')">
                <a href="javascript:;" >
                    <div class="icon">
                        <svg fill="none" height="512" viewBox="0 0 100 100" width="512"><g><path d="m5 19.5c0-4.1421 3.35787-7.5 7.5-7.5h75c4.1421 0 7.5 3.3579 7.5 7.5s-3.3579 7.5-7.5 7.5h-75c-4.14214 0-7.5-3.3579-7.5-7.5z"/><path d="m5 49.5c0-4.1421 3.35787-7.5 7.5-7.5h45c4.1421 0 7.5 3.3579 7.5 7.5s-3.3579 7.5-7.5 7.5h-45c-4.14214 0-7.5-3.3579-7.5-7.5z"/><path d="m5 79.5c0-4.1421 3.35787-7.5 7.5-7.5h75c4.1421 0 7.5 3.3579 7.5 7.5s-3.3579 7.5-7.5 7.5h-75c-4.14214 0-7.5-3.3579-7.5-7.5z"/></g></svg>
                    </div>
                    <p>A-Z List</p>
                </a>
            </div>
            <div class="item" @click="triggerComponent('MYBETS', 'open')">
                <a href="javascript:;" >
                    <div class="icon">
                        <svg height="511pt" viewBox="-55 1 511 511.999" width="511pt"><path d="m113.199219 95.53125v-95.53125h-1.066407c-3.988281 0-7.808593 1.585938-10.628906 4.402344l-96.601562 96.601562c-2.820313 2.820313-4.402344 6.640625-4.402344 10.628906v1.070313h95.53125c9.46875 0 17.167969-7.703125 17.167969-17.171875zm0 0"/><path d="m336.464844 401.4375v-354.207031c0-25.96875-20.996094-47.230469-47.230469-47.230469h-145.96875v95.53125c0 26.042969-21.191406 47.230469-47.234375 47.230469h-95.53125v258.675781c0 26.042969 21.1875 47.230469 47.230469 47.230469h241.503906c25.96875 0 47.230469-20.996094 47.230469-47.230469zm-159.933594-49.371094h-80.5c-8.300781 0-15.03125-6.730468-15.03125-15.03125 0-8.300781 6.730469-15.03125 15.03125-15.03125h80.5c8.304688 0 15.03125 6.730469 15.03125 15.03125 0 8.300782-6.726562 15.03125-15.03125 15.03125zm64.402344-64.402344h-144.902344c-8.300781 0-15.03125-6.726562-15.03125-15.03125 0-8.300781 6.730469-15.03125 15.03125-15.03125h144.902344c8.300781 0 15.03125 6.730469 15.03125 15.03125 0 8.304688-6.730469 15.03125-15.03125 15.03125zm0-64.398437h-144.902344c-8.300781 0-15.03125-6.730469-15.03125-15.03125s6.730469-15.03125 15.03125-15.03125h144.902344c8.300781 0 15.03125 6.730469 15.03125 15.03125s-6.730469 15.03125-15.03125 15.03125zm0 0"/><path d="m366.527344 65.121094v336.316406c0 42.617188-34.671875 77.292969-77.292969 77.292969h-222.226563c5.96875 19.25 23.9375 33.269531 45.125 33.269531h241.5c25.972657 0 47.234376-20.996094 47.234376-47.230469v-354.207031c0-21.535156-14.445313-39.820312-34.339844-45.441406zm0 0"/></svg>                        
                    </div>
                    <p>{{ $t('sportsbook.1') }} <span v-if="betCounter != null" style="color: var(--client-c3);">({{betCounter}})</span></p>
                </a>
            </div>
            <div class="item">
                <a href="javascript:;"  @click="toNav('HOME')">
                    <div class="icon">
                        <svg enable-background="new 0 0 32 32" height="512" viewBox="0 0 32 32" width="512"><g id="Home"><path d="m29.593 15.318-.015 1.282c-.003.982-.668 1.496-1.324 1.496-.241 0-.613-.068-1.012-.395l-11.228-9.043-11.234 9.049c-.395.32-.766.389-1.007.389-.656 0-1.321-.514-1.324-1.496l-.015-1.281c-.005-.826.458-1.811 1.099-2.336l11.865-9.748c.357-.293.873-.293 1.23 0l11.865 9.748c.642.525 1.105 1.509 1.1 2.335zm-9.085 9.586h-8.801v4.082h8.801zm-8.801-3.968h8.801v2.031h-8.801zm14.309-1.735-10.002-8.055-10.018 8.069c-.073.061-.145.094-.217.145v6.719c0 1.604 1.304 2.908 2.906 2.908h1.085v-9.02c0-.535.435-.969.969-.969h10.738c.535 0 .969.434.969.969v9.02h1.035c1.603 0 2.906-1.305 2.906-2.908v-6.627c-.124-.081-.246-.149-.371-.251zm2.478-6.219-11.865-9.748c-.357-.293-.873-.293-1.23 0l-11.866 9.748c-.641.525-1.104 1.51-1.099 2.336l.015 1.282c.003.982.668 1.496 1.324 1.496.241 0 .612-.068 1.007-.389l11.233-9.049 11.229 9.043c.398.326.771.395 1.012.395.656 0 1.321-.514 1.324-1.496l.015-1.281c.005-.827-.458-1.811-1.099-2.337zm0 0-11.865-9.748c-.357-.293-.873-.293-1.23 0l-11.866 9.748c-.641.525-1.104 1.51-1.099 2.336l.015 1.282c.003.982.668 1.496 1.324 1.496.241 0 .612-.068 1.007-.389l11.233-9.049 11.229 9.043c.398.326.771.395 1.012.395.656 0 1.321-.514 1.324-1.496l.015-1.281c.005-.827-.458-1.811-1.099-2.337z"/></g></svg>
                    </div>
                    <p>{{ $t('sportsbook.2') }}</p>
                </a>
            </div>
            <div class="item">
                <a href="javascript:;" @click="toNav('IN_PLAY')">
                    <div class="icon">
                        <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g id="Play"><path d="m37.324 20.026-22-12.412a4.685 4.685 0 0 0 -4.711.036 4.528 4.528 0 0 0 -2.28 3.938v24.824a4.528 4.528 0 0 0 2.28 3.938 4.687 4.687 0 0 0 4.711.036l22-12.412a4.543 4.543 0 0 0 0-7.948z"/></g></svg>
                    </div>
                    <p>{{ $t('sportsbook.3') }}</p>
                </a>
            </div>
            <div class="item">
                <router-link to="/casino" >
                    <div class="icon">
                        <svg enable-background="new 0 0 509.103 509.103" height="512" viewBox="0 0 509.103 509.103" width="512" xmlns="http://www.w3.org/2000/svg"><g id="XMLID_2954_"><path id="XMLID_2977_" d="m75.181 269.552h-75.181c3.313 57.496 25.637 111.39 63.95 154.388l53.223-53.223c-23.537-27.791-38.81-62.787-41.992-101.165z"/><path id="XMLID_2978_" d="m117.173 138.386-53.223-53.223c-38.313 42.999-60.637 96.892-63.95 154.389h75.181c3.182-38.379 18.455-73.375 41.992-101.166z"/><path id="XMLID_2990_" d="m433.921 239.552h75.182c-3.315-57.495-25.638-111.39-63.951-154.389l-53.223 53.224c23.537 27.79 38.811 62.786 41.992 101.165z"/><path id="XMLID_3000_" d="m254.551 239.552c-8.271 0-15 6.729-15 15 .754 19.872 29.25 19.867 30 0 0-8.272-6.728-15-15-15z"/><path id="XMLID_3008_" d="m404.551 254.552c0-82.71-67.29-150-150-150-198.722 7.541-198.668 292.489.002 300 82.708 0 149.998-67.291 149.998-150zm-60 15h-47.58c-4.527 12.764-14.656 22.893-27.42 27.42v47.58h-30v-47.58c-12.764-4.527-22.893-14.656-27.42-27.42h-47.58v-30h47.58c4.527-12.764 14.656-22.893 27.42-27.42v-47.58h30v47.58c12.764 4.527 22.893 14.656 27.42 27.42h47.58z"/><path id="XMLID_3020_" d="m239.551 75.181v-75.18c-57.495 3.313-111.389 25.636-154.388 63.949l53.223 53.224c27.791-23.538 62.786-38.811 101.165-41.993z"/><path id="XMLID_3026_" d="m423.939 63.951c-42.998-38.313-96.892-60.637-154.388-63.95v75.181c38.378 3.182 73.373 18.455 101.165 41.992z"/><path id="XMLID_3078_" d="m269.551 433.922v75.181c57.495-3.314 111.39-25.637 154.388-63.95l-53.223-53.223c-27.792 23.537-62.787 38.81-101.165 41.992z"/><path id="XMLID_3080_" d="m85.163 445.152c42.999 38.313 96.893 60.637 154.388 63.95v-75.181c-38.379-3.182-73.374-18.455-101.165-41.992z"/><path id="XMLID_3081_" d="m391.929 370.717 53.223 53.223c38.314-42.998 60.637-96.893 63.951-154.388h-75.182c-3.181 38.378-18.455 73.374-41.992 101.165z"/></g></svg>
                    </div>
                    <p>Casino</p>
                </router-link>
            </div>
        </div>
	</div>
</template>

<style lang="scss">
    #pragmaticSportsIframeContainer iframe{
        min-height: 1000px;    
    }
    #app:not(.mobile) div#pragmaticSportsIframeContainer{
        height: calc(100vh - 105px) !important;
        iframe{
            min-height: 100%;
            height: 100% !important;
        }
    }
    #app.mobile div#pragmaticSportsIframeContainer {
        top: 55px;
        height: calc(100% - 118px);
        position: fixed;
        width: 100%;
        iframe{
            min-height: auto  !important;
        }
    }
    #app.inplay,
    #app.sportsbook,
    #app.live{
        footer{
            display: none !important;
        }
    }
    #app.mobile.live,
    #app.mobile.sportsbook{
        position: fixed!important;
        top: 0;
        height: 100%;
        left: 0;
        width: 100%;
        overflow: hidden;
    } 
    #app.mobile.inplay, 
    #app.mobile.sportsbook, 
    #app.mobile.live{
        .inc{
            padding: 0px !important;
        }
        .mobile-bottom-bar{
           display: none;
        }
        .mobile-bottom-bar.sportsbook{
            display: flex !important;
        }
    }
</style>
<script>
    export default {
        name: 'Live',
        metaInfo () {
            return {
                meta: [
                { 'http-equiv':'Content-Security-Policy', content: "upgrade-insecure-requests" },
                ]
            }
        },
        data() {
            return {
                loading: true,
                game_url: null,
                game_data: null,
                is_script: false,
                betCounter:null,
                iframeContainer: null,
                iframe:null,
                auth : {},
            }
        },
        created () {
            this.fetchData();
            if(this.isMobile){
                document.querySelector("body").style.setProperty('--mobileHeight', window.innerHeight + 'px');
            }
        },
        beforeCreate(){
            if(this.$store.getters['auth/user_detail'].detail.sport_provider == 3){
                this.$router.push('/sportmaintenance')
            }
        },
        watch:{
            loggedIn(val,oldVal){
                if(!val){
                    var message = {
                        "command": "SB.PPBET_SB.SET_AUTH_TOKEN",
                        "parameters": {
                            "authtoken": null,
                            "tokenExpiry" : null,
                            "currency": null,
                            "currencySymbol": null,
                            "playerId": nulld
                        }
                    };

                    const iframe = window.document.querySelector('#pragmaticSportsIframe');
                    iframe.contentWindow.postMessage(message, '*');
                    console.log('User Set Auth Token! : ' + this.auth.token);
                }
            },
            balance(val,oldVal){
                this.setUserBalance();
            }
        },
        mounted () {
            this.addHandler();
        },
        destroyed() {
            this.removeHandler();
        },
        methods: {
            fetchData() {
                this.loading = true;
                axios.get('/sportsbook', { params: { mobile : this.isMobile}})
                .then((response)=>{

                    this.loading = false;
                    this.is_script = response.data.config.is_script
                    this.auth = response.data.auth;

                    if(this.is_script)
                    {
                        this.game_data = response.data.data
                    }
                    else
                    {
                        this.game_url = response.data.config.url
                    }   
                })
                .catch((err)=>{
                });

            },
            toNav(nav) {
                var message = {
                    "command": "SB.PPBET_SB.DEEPLINK",
                    "parameters": {
                        name: nav,
                        type:'page',
                        sportID:""
                    }
                };
                let iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');
            },
            triggerComponent(nav, toggle) {
                var message = {
                    "command": "SB.PPBET_SB.DEEPLINK",
                    "parameters": {
                        name: nav,
                        toggle: toggle
                    }
                };
                let iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');
            },
            addHandler() {
                window.addEventListener('message', this.eventListener);
            },
            removeHandler(){
                window.removeEventListener('message', this.eventListener);
            },
            eventListener(event)
            {
                if(process.env.NODE_ENV == 'development')
                {
                    if(event.origin == 'http://localhost:8080')
                    {
                        return false;
                    }
                }

                var data = JSON.parse(event.data);
                if(data.command == "EXT.PPBET_SB.UPDATE_SIZE"){
                    let calcHeight = data.parameters.height;
                    let iframeContainer = document.getElementById("pragmaticSportsIframeContainer");
                    iframeContainer.style.height = calcHeight + 'px';
                }

                if(data.command == "EXT.PPBET_SB.OPEN_DEPOSIT"){
                    this.$router.push({ name : 'User', params:{ section: 'deposit' } })
                }
                
                if(data.command == "EXT.PPBET_SB.BET_COUNTER"){
                    this.betCounter = data.parameters.count;
                }

                if(data.command == 'EXT.PPBET_SB.SB_READY')
                {
                    this.setAuthToken();
                    this.setUserBalance();
                    this.setUserLanguage();
                }
            },
            setAuthToken()
            {
                var message = {
                    "command": "SB.PPBET_SB.SET_AUTH_TOKEN",
                    "parameters": {
                        "authtoken": this.auth.token,
                        "tokenExpiry" : this.auth.expiry,
                        "currency": this.auth.currency,
                        "currencySymbol": this.auth.currencySymbol,
                        "playerId": this.auth.playerId
                    }
                };


                const iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');
                console.log('User Set Auth Token! : ' + this.auth.token);
            },
            setUserBalance(balance = 0)
            {
                var message = {
                    "command": "SB.PPBET_SB.GET_BALANCE",
                    "parameters": {
                        "balance": parseFloat(this.user.balance),
                    }
                };

                const iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');

                console.log('User Set Balance! : ' + parseFloat(this.user.balance));
            },
            setUserLanguage(language)
            {
                var message = {
                    "command": "SB.PPBET_SB.SET_LANGUAGE",
                    "parameters": {
                        "language": this.$i18n.locale,
                    }
                };

                const iframe = window.document.querySelector('#pragmaticSportsIframe');
                iframe.contentWindow.postMessage(message, '*');

                console.log('User Set Language! : ' + this.$i18n.locale);
            }
        },
        computed:
        {
            user()
            {
                return this.$user();
            },
            balance()
            {
                return this.user.balance;
            },
            loggedIn() {
                return this.$store.getters['auth/isLoggedIn']
            },
        }
    }
</script>